module.exports = new __parcel__URL__("lowest-priority.c391bcb1.svg").toString();